import { useMutation } from '@apollo/client';
import { gql } from '@apollo/client/core';

const UPDATE_TIMEZONE_MUTATION = gql`
  mutation UpdateTimezone($timezone: String!) {
    updateTimezone(timezone: $timezone) {
      success
      timezone
    }
  }
`;

export const useUpdateTimezone = () => {
  const [updateTimezone, { loading, error, data }] = useMutation(
    UPDATE_TIMEZONE_MUTATION
  );

  const handleUpdateTimezone = async (timezone) => {
    try {
      const result = await updateTimezone({
        variables: { timezone },
      });
      return result.data?.updateTimezone;
    } catch (err) {
      console.error('Error updating timezone:', err);
      throw err;
    }
  };

  return { handleUpdateTimezone, loading, error, data };
};
